var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#12ad2b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 384c0 31.417 25.472 56.889 56.889 56.889h398.222C486.528 440.889 512 415.417 512 384v-63.582H0V384zM455.111 71.111H56.889C25.472 71.111 0 96.583 0 128v64.418h512V128c0-31.417-25.472-56.889-56.889-56.889z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 320h512V192H0v128z",
    fill: "#ffce00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.951 87.7a57.165 57.165 0 0 0-2.17 2.367l-.001.001-.001.002a56.551 56.551 0 0 0-3.5 4.499c-.288.412-.575.823-.852 1.242v.001A56.584 56.584 0 0 0 0 127.163v256c0 15.751 6.404 30.006 16.749 40.307L177.778 256 15.951 87.7z",
    fill: "#d21034"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.055 289.559l23.111-16.782 23.097 16.782-8.818-27.164 23.097-16.782h-28.558l-8.818-27.164-8.832 27.164h-28.558l23.111 16.782-8.832 27.164zM391.17 289.559l23.111-16.782 23.097 16.782-8.818-27.164 23.097-16.782h-28.558l-8.818-27.164-8.832 27.164h-28.558l23.111 16.782-8.832 27.164z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSt);
export default __webpack_public_path__ + "static/media/st.6435eb98d95486ac94f7f58a96489869.svg";
export { ForwardRef as ReactComponent };